import {ChannelsContainer, ChannelsHeader, IconsContainer, StyledLink} from "./StyledComponents";
import ChannelIcon, {Channel} from "./channel-icon/ChannelIcon";
import {Typography} from "@kaltura/ds-react-components";
import {useMemo} from "react";
import {sortChannels} from "./helper";
import {useButtonAnalytics, useTimeShiftedArray} from "@mediaspace/hooks";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";

export interface ChannelsProps {
    translatedTitle: string;
    translatedLinkString: string;
    titleLink: string;
    linkAriaLabel: string;
    openTitleInNewTab: boolean;
    channelsInLine: number;
    maxLinesNumber: number;
    timeShift: number;
    disableEntitlements: boolean;
    channels: Channel[];
    sortBy: string;
}

const Channels = (props: ChannelsProps) => {

    const {
        translatedTitle,
        translatedLinkString,
        titleLink,
        linkAriaLabel,
        channelsInLine,
        maxLinesNumber,
        timeShift = 0,
        disableEntitlements,
        channels,
        sortBy,
    } = props;

    const totalItems = channelsInLine * maxLinesNumber;

    const sortedChannels = useMemo(() => sortChannels(channels, sortBy), [channels, sortBy]);
    const channelsToShow = useTimeShiftedArray(
        sortedChannels,
        // 1 minute = 60,000 milliseconds
        timeShift * 60000,
        totalItems,
    );

    const sendButtonAnalytics = useButtonAnalytics();

    return (
        <ChannelsContainer>
            <ChannelsHeader>
                <Typography variant={"h3"}>
                    {translatedTitle}
                </Typography>
                <StyledLink
                    href={titleLink}
                    aria-label={linkAriaLabel}
                    onClick={() => sendButtonAnalytics("Channels collection component - See all", ButtonClickAnalyticsType.LINK)}
                >
                    <Typography variant={"buttonLabel1"}>
                        {translatedLinkString}
                    </Typography>
                </StyledLink>
            </ChannelsHeader>
            <IconsContainer>
                {channelsToShow.map(channel =>
                    <ChannelIcon
                        channel={channel}
                        itemsInLine={channelsInLine}
                        disableEntitlements={disableEntitlements}
                    />
                )}
            </IconsContainer>
        </ChannelsContainer>
    );
}

export default Channels;
